import { NavLink } from "react-router-dom";

import { useUser } from "@/hooks/useUser";
import type { Papel } from "@/types/api";

interface NavItem {
  to: string;
  label: string;
  allowed: Papel[];
}

const items: NavItem[] = [
  { to: "/", label: "Início", allowed: ["administrativo", "medico"] },
  { to: "/empresas", label: "Empresas", allowed: ["administrativo", "medico"] },
  { to: "/colaboradores", label: "Colaboradores", allowed: ["administrativo", "medico"] },
  { to: "/medicos", label: "Médicos", allowed: ["administrativo", "medico"] },
  { to: "/documentos", label: "Documentos (PCMSO/PGR)", allowed: ["administrativo", "medico"] },
  { to: "/catalogos", label: "Catálogos", allowed: ["administrativo", "medico"] },
  { to: "/atendimentos", label: "Atendimentos", allowed: ["administrativo", "medico"] },
  { to: "/asos", label: "ASOs", allowed: ["administrativo", "medico"] },
  { to: "/pendencias", label: "Pendências", allowed: ["administrativo", "medico"] },
];

export function NavSidebar() {
  const { data: user } = useUser();
  const papel = user?.papel;

  function visible(it: NavItem) {
    return !papel || it.allowed.includes(papel);
  }

  const link = "block rounded-md px-3 py-2 text-sm font-medium text-ink hover:bg-anarosa-50 hover:text-anarosa-700";
  const active = "bg-anarosa text-white hover:bg-anarosa-600 hover:text-white";

  return (
    <aside className="w-64 shrink-0 border-r border-gray-200 bg-white">
      <div className="border-b border-gray-200 px-6 py-5">
        <span className="font-display text-lg font-semibold text-anarosa">ASO</span>
        <p className="text-xs text-ink-muted">Grupo Ana Rosa</p>
      </div>
      <nav className="p-3 space-y-1">
        {items.filter(visible).map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === "/"}
            className={({ isActive }) => `${link} ${isActive ? active : ""}`}
          >
            {it.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
